import React from "react";
import { isReloy } from "../../../../utils/isClient";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ZeroRewardPoints(_ref) {
  var _redux$webView;
  var isMobile = _ref.isMobile,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config;
  var history = router === null || router === void 0 ? void 0 : router.history;
  var isInternalWebview = redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.internalWebview;
  var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  return /*#__PURE__*/_jsxs("div", {
    className: "relative pt-12 pb-5",
    id: "zeroRewards",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex justify-center",
      children: /*#__PURE__*/_jsx("p", {
        className: "text-sm md:text-xl font-semibold text-center",
        children: "Refer your loved ones, unlock exclusive products and claim your rewards"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "relative w-full pt-5",
      children: /*#__PURE__*/_jsx("img", {
        className: "w-full h-full object-cover rounded-xl ",
        src: config !== null && config !== void 0 && config.darkMode ? isMobile ? "https://cdn.loyalie.in/1787340907393_zeroRewards_mob" : "https://cdn.loyalie.in/1787340806047_zero_Reward_web" : isMobile ? "https://cdn.loyalie.in/1738221402996_zeroReward_mob" : "https://cdn.loyalie.in/1738221320354_zeroReward_web",
        alt: "No Rewards Banner"
      })
    }), !isReloy(config) && /*#__PURE__*/_jsx("div", {
      className: "flex justify-center",
      children: /*#__PURE__*/_jsx("button", {
        className: "bg-primary text-white font-semibold px-10 py-3 rounded-lg",
        onClick: function onClick() {
          if (isInternalWebview && isIOS) {
            var _window;
            var valueToSend = {
              type: "OPEN_REFERRAL_IN_BROWSER"
            };
            (_window = window) === null || _window === void 0 || (_window = _window.webkit) === null || _window === void 0 || (_window = _window.messageHandlers) === null || _window === void 0 || _window.jsMessageHandler.postMessage(valueToSend);
          } else {
            if (history !== null && history !== void 0 && history.push) {
              history.push("/gift-and-earn");
            } else {
              window.location.href = "/gift-and-earn";
            }
          }
        },
        children: "Refer Now"
      })
    })]
  });
}
export default ZeroRewardPoints;